import { render, staticRenderFns } from "./gen4.vue?vue&type=template&id=50e86ea3&scoped=true"
import script from "./gen4.vue?vue&type=script&lang=js"
export * from "./gen4.vue?vue&type=script&lang=js"
import style0 from "./gen4.vue?vue&type=style&index=0&id=50e86ea3&prod&lang=css"
import style1 from "./gen4.vue?vue&type=style&index=1&id=50e86ea3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e86ea3",
  null
  
)

export default component.exports